import { $t } from 'src/plugins/i18n'
import { stringToNumber } from 'src/tpbp-core/utils/common.utils'
import type { Scalar } from 'src/tpbp-core/models/global.type'

export const standardDateControls = {
  min: (_record, { D_150Y }) => D_150Y,
  max: (_record, { TODAY }) => TODAY,
}

export const maxHundredPercentRules = () => [
  (v) =>
    stringToNumber(v) <= 100 ||
    $t('models.portfolios.errors.maxBlockedPart', { amount: 100 }),
]

export const enumLabelIsKey = (record, _helpers, field) => record[field.key]

export const defaultToday = () => {
  const TODAY = new Date()

  return TODAY.toISOString()
}

export const defaultFieldValueEnum = ({ field }) => {
  const value = field?.enums?.[0]

  return value?.key || value
}

export function checkChangeBeforeValidate(
  hasChanged: boolean,
  validationFunction: () => number | undefined,
) {
  if (!hasChanged) {
    return
  }
  return validationFunction()
}

export function removeRowFromEnumKeys(
  enumKeys: Scalar[],
  keyToRemove: Scalar,
): Scalar[] {
  return enumKeys.filter((key) => key !== keyToRemove)
}

export function keepRowFromEnumKeys(
  enumKeys: Scalar[],
  keyToKeep: Scalar,
): Scalar[] {
  return enumKeys.filter((key) => key === keyToKeep)
}
